import qs from 'qs';

export const makeQuery = obj => {
  return qs.stringify(obj, {addQueryPrefix: true, arrayFormat: 'brackets'});
};
